<template>
  <div style="background-color: #fff">
    <div
      class="pa-4"
      style="
        font-size: 18px;
        background-color: #c2b59c;
        text-align: center;
        color: #fff;
      "
    >
      ข้อตกลงและเงื่อนไข
    </div>

    <v-card class="ma-4 px-4 py-6" style="box-shadow: none">
      <div style="font-weight: 700; font-size: 16px" class="pb-2">
        นโยบายการเปลี่ยน/คืนสินค้า
      </div>
      <p class="indent">
        สินค้าทุกชิ้นของ foodguru
        ผ่านการตรวจสอบคุณภาพและความถูกต้องก่อนส่งถึงมือลูกค้าทุกครั้ง
        และเพื่อตอบสนองความพึงพอใจหลังการขายของลูกค้า ทางบริษัทยินดีรับเปลี่ยน /
        คืนสินค้า หากเกิดข้อผิดพลาดภายใต้เงื่อนไขที่ทางบริษัทฯ กำหนด
      </p>

      <div style="font-weight: 700; font-size: 16px" class="pb-2 mt-2">
        ข้อตกลงและเงื่อนไขในการเปลี่ยน / คืนสินค้า
      </div>
      <ul>
        <li>
          บริษัทฯ ขอสงวนสิทธิ์ในการเปลี่ยน / คืนสินค้า จากสาเหตุการเปลี่ยนใจ
          สั่งสินค้าผิด หรือปัญหาอื่นนอกเหนือขอบเขตด้านคุณภาพสินค้า
          รวมถึงความเสียหายที่ไม่ได้เกิดจากข้อผิดพลาดของทางบริษัทฯ
        </li>
        <li>
          การเปลี่ยน / คืนสินค้า จะต้องผ่านการตรวจสอบตามเงื่อนไขของบริษัทฯ
          และผู้ผลิตในทุกกรณี โดยถือคำตัดสินของทางบริษัทฯ เป็นที่สิ้นสุด
          ในกรณีที่ตรวจสอบแล้วพบว่าไม่อยู่ภายใต้เงื่อนไข
          ขอสงวนสิทธิ์ในการเปลี่ยน / คืน สินค้า
        </li>
        <li>
          การแจ้งเปลี่ยน / คืนสินค้า ต้องดำเนินการภายใน 7 วัน หลังได้รับสินค้า
          หากเกินระยะเวลาที่กำหนด ทางบริษัทฯ
          ขอสงวนสิทธิ์ในการเปลี่ยนหรือคืนสินค้า
        </li>
        <li>
          ด้วยข้อจำกัดและความปลอดภัยด้านสุขอนามัย ทางบริษัทฯ
          ขอสงวนสิทธิ์ในการเปลี่ยน / คืนสินค้าในหมวดหมู่อาหาร ได้แก่ เนื้อสัตว์
          อาหารทะเล อาหารแช่แข็ง อาหารแห้ง ขนมหวาน ขนมอบ (เบเกอรี)
          และเครื่องดื่ม ยกเว้นกรณีที่เกิดจากการจัดส่งสินค้าไม่ตรงตามคำสั่งซื้อ
        </li>
        <li>
          สินค้าที่ต้องการเปลี่ยน / คืน ต้องเป็นสินค้าที่สั่งซื้อผ่านเว็บไซต์
          เท่านั้น
        </li>
        <li>
          สินค้าภายใต้การจัดรายการ อาทิ สินค้าลดราคา ของแถม
          สินค้าแลกรับหรือแลกซื้อ ไม่สามารถเปลี่ยนหรือแลกคืนเป็นเงินได้
          และต้องถูกส่งคืนพร้อมสินค้าหลักในกรณีที่มีการเปลี่ยน / คืนสินค้า
        </li>
        <li>
          บริษัทฯ ขอสงวนสิทธิ์ในการคืนค่าบริการการขนส่ง
          และค่าธรรมเนียมบริการอื่น ๆ
        </li>
      </ul>

      <div style="font-weight: 700; font-size: 16px" class="pb-2 mt-4">
        ขั้นตอนการเปลี่ยน / คืนสินค้า
      </div>
      <ol>
        <li>
          แจ้งความต้องการเปลี่ยนหรือคืนสินค้ากับทางบริษัทฯ กรุณาติดต่อ โทร.
          02-267-7888 หรือทาง E-mail aroi@foodguru.co.th
          โดยแนบหลักฐานในการสั่งซื้อ และรายละเอียดของสินค้าที่แจ้ง
        </li>
        <li>
          เมื่อได้รับการยืนยันจากเจ้าหน้าที่ กรุณาจัดส่งสินค้าพร้อมกล่องสินค้า
          รวมถึงสินค้าที่ได้รับภายใต้การจัดรายการ กลับมายังที่อยู่ด้านล่างนี้ :
          58 ชั้นที่ 2 ซอยเพชรเกษม 41 ถนนเพชรเกษม แขวงบางแค เขตบางแค กรุงเทพฯ
          10160
        </li>
        <li>
          หลังตรวจสอบสินค้าที่ถูกส่งคืนแล้ว หากครบถ้วนตามเงื่อนไขที่กำหนด
          ทางบริษัทฯ จะติดต่อกลับเพื่อยืนยัน และดำเนินการเปลี่ยน / คืน
          สินค้าโดยเร็วที่สุด
        </li>
        <li>
          หากมีสินค้าพร้อมส่ง ทางบริษัทฯ จะดำเนินการจัดส่งภายใน 7 -14 วันทำการ
          หากไม่มีสินค้าจะแจ้งเปลี่ยนสินค้าทดแทน
          หรือยกเลิกคำสั่งซื้อและดำเนินการคืนเงินภายใน 15 วันทำการ
        </li>
      </ol>

      <div style="font-weight: 700; font-size: 16px" class="pb-2 mt-4">
        นโยบายความเป็นส่วนตัวสำหรับลูกค้า
      </div>
      <p class="indent">
        บริษัท ฟู้ดกูรู จำกัด (ต่อไปนี้เรียกว่า "เรา")
        เคารพสิทธิความเป็นส่วนตัวของลูกค้า
        รวมถึงบุคคลธรรมดาที่ดำเนินการให้ลูกค้าซึ่งเป็นนิติบุคคลด้วย
        (ต่อไปนี้เรียกว่า "ท่าน")
        และเพื่อให้เกิดความมั่นใจว่าท่านได้รับความคุ้มครองข้อมูลส่วนบุคคล
        จึงได้จัดทำนโยบายความเป็นส่วนตัวฉบับนี้ขึ้น
        เพื่อแจ้งให้ทราบถึงรายละเอียดที่เกี่ยวข้องกับการเก็บรวบรวม การใช้
        และการเปิดเผย (รวมเรียกว่า "การประมวลผล") รวมตลอดถึงการลบและทำลาย
        ข้อมูลส่วนบุคคลของท่านทั้งช่องทางออนไลน์ และช่องทางอื่น ๆ
        ตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด ดังนี้
      </p>
      <ol>
        <li>
          วัตถุประสงค์การประมวลผลข้อมูลส่วนบุคคล
          <ol>
            <li>
              เพื่อใช้ในการดำเนินการตามคำขอของท่านก่อนเข้าทำสัญญาหรือเพื่อปฏิบัติตามสัญญาซึ่งท่านเป็นคู่สัญญากับเรา
              เช่น เพื่อการขายสินค้า และ/หรือ บริการให้แก่ท่าน
              หรือปฏิบัติตามสัญญาใด ๆ ซึ่งท่านเป็นคู่สัญญา ซึ่งรวมถึง
              การจัดการบัญชีผู้ใช้ (Account) ของท่าน การจัดส่งสินค้า
              การดำเนินการเกี่ยวกับบัญชีและการเงิน การบริการหลังการขาย
              และการคืนสินค้า และดำเนินการใด ๆ เพื่อให้ท่านได้รับสินค้าและ/หรือ
              บริการ หรือตามที่ท่านได้ร้องขอ ทั้งนี้ รวมถึงกรณีการดำเนินการใด ๆ
              เพื่อให้เป็นไปตามการอนุญาตให้ใช้สิทธิ
            </li>
            <li>
              เพื่อประโยชน์โดยชอบด้วยกฎหมายของเราหรือของบุคคลอื่น
              <div>
                <p>
                  (1)&nbsp;&nbsp;เพื่อให้เราสามารถจัดการ พัฒนา และดำเนินการใด ๆ
                  เพื่อให้สามารถดำเนินธุรกิจได้ซึ่งรวมถึงการดำเนินการใด ๆ
                  เพื่อให้เป็นไปตามการอนุญาตให้ใช้สิทธิ
                </p>
                <p class="indent">
                  การบริหารจัดการและพัฒนาสินค้า และ/หรือ บริการ (รวมถึงเว็บไซต์
                  และแอปพลิเคชัน) การตรวจสอบและป้องกันการฉ้อโกง
                  หรืออาชญากรรมอื่น ๆ
                </p>
                <p class="indent">
                  การจัดการความสัมพันธ์ลูกค้าและผู้ที่อาจเป็นลูกค้า
                  การบำรุงรักษาและการใช้ระบบไอที
                </p>
                <p>
                  (2)&nbsp;&nbsp;เพื่อประโยชน์ทางด้านความปลอดภัย เช่น
                  จัดให้มีมาตรการรักษาความปลอดภัย
                  ซึ่งรวมถึงข้อมูลส่วนบุคคลของท่านด้วย เช่น การเข้าสถานที่ของเรา
                </p>
                <p class="indent">
                  การเข้าสู่ระบบ (Log in) เข้าเว็บไซต์หรือแอปพลิเคชัน
                </p>
                <p>
                  (3)&nbsp;&nbsp;เพื่อดำเนินการทางการตลาด และวิเคราะห์ข้อมูล
                  (Marketing and Data Analysis) เช่น
                  การแจ้งข่าวสารและสิทธิประโยชน์ ผ่านทาง อีเมล เอสเอ็มเอส
                </p>
                <p class="indent">
                  แอปพลิเคชัน โซเชียลมีเดีย โทรศัพท์ ไดเร็กเมล
                  รวมถึงเพื่อประโยชน์ในการวิจัยทางการตลาด เช่น ทำแบบสอบถาม
                  เข้าสัมภาษณ์
                </p>
                <p>(4)&nbsp;&nbsp;เพื่อการใช้สิทธิเรียกร้องทางกฎหมาย</p>
              </div>
            </li>
            <li>
              เพื่อป้องกันและระงับอันตรายต่อชีวิต ร่างกาย
              หรือสุขภาพของท่านหรือบุคคลอื่น เช่น การติดต่อในกรณีฉุกเฉิน
              การควบคุมและป้องกันโรคติดต่อ
            </li>
            <li>
              เพื่อให้สามารถปฏิบัติตามกฎหมาย เช่น
              การปฏิบัติตามบทบัญญัติของกฎหมาย กฏระเบียบ
              และคำสั่งของผู้ที่มีอำนาจตามกฎหมาย
            </li>
            <li>
              เพื่อการปฏิบัติหน้าที่ในการดำเนินภารกิจเพื่อประโยชน์สาธารณะของเรา
              หรือปฏิบัติหน้าที่ในการใช้อำนาจรัฐที่ได้มอบให้
            </li>
            <li>
              กรณีที่ท่านให้ความยินยอมเราจะประมวลผลข้อมูลส่วนบุคคล
              <p class="indent">
                (1)&nbsp;&nbsp;เพื่อให้เรา บริษัทในกลุ่มของเรา และพันธมิตร
                ส่งข่าวสารและสิทธิประโยชน์ผ่านทางอีเมล เอสเอ็มเอส แอปพลิเคชัน
                โซเชียลมีเดีย โทรศัพท์ และไดเร็กเมล
              </p>
              <p class="indent">
                (2)&nbsp;&nbsp;เพื่อให้เราดำเนินการจัดกิจกรรมนอกจากที่กล่าวมาข้างต้น
                โดยอาจเก็บข้อมูลส่วนบุคคลของท่านเพิ่มเติม
                โดยจะแจ้งให้ทราบและขอความยินยอมจากท่านใหม่เป็นคราว ๆ ไป ทั้งนี้
                ท่านสามารถศึกษารายละเอียดเกี่ยวกับความยินยอมได้ในข้อ 4
              </p>
            </li>
          </ol>
        </li>
        <li>
          ข้อมูลส่วนบุคคลที่เก็บรวบรวม
          <ol>
            <li>
              เมื่อท่านจะซื้อสินค้า และ/หรือ บริการ
              รวมทั้งการเข้าเป็นสมาชิกเว็บไซต์ แอปพลิเคชัน
              หรือบัตรสิทธิประโยชน์ต่าง ๆ เราจะเก็บรวบรวมข้อมูลส่วนบุคคล ดังนี้
              <div>
                <p>
                  (1)&nbsp;&nbsp;ข้อมูลส่วนตัว เช่น ชื่อ นามสกุล
                  วันเดือนปีที่เกิด สถานภาพ ที่อยู่
                  ข้อมูลตามที่ระบุในบัตรประจำตัวประชาชน หนังสือเดินทาง Facebook
                  ID Line ID ประวัติการสนทนา
                </p>
                <p>
                  (2)&nbsp;&nbsp;ข้อมูลการติดต่อ เช่น อีเมล์ เบอร์โทรศัพท์
                  ที่อยู่ ช่องทางติดต่อในโซเชียลมีเดีย สถานที่ทำงาน
                </p>
                <p>
                  (3)&nbsp;&nbsp;ข้อมูลเกี่ยวกับงานของท่าน เช่น อาชีพ ตำแหน่ง
                  ประสบการณ์การทำงาน
                </p>
                <p>
                  (4)&nbsp;&nbsp;ข้อมูลเกี่ยวกับการซื้อสินค้า และ/หรือ บริการ
                  เช่น ประวัติการซื้อสินค้า ประวัติการเคลมสินค้า ข้อร้องเรียน
                </p>
                <p>
                  (5)&nbsp;&nbsp;ข้อมูลเกี่ยวกับการเงิน เช่น หมายเลขบัญชีธนาคาร
                  ข้อมูลบัตรเครดิต/เดบิต ข้อมูลรายได้ สิทธิประโยชน์ที่ท่านได้รับ
                  ประวัติการจ่ายเงิน รายได้ เลขที่บัญชีธนาคาร
                </p>
                <p>
                  (6)&nbsp;&nbsp;ข้อมูลที่ท่านได้ให้ไว้แก่เมื่อท่านติดต่อเรา
                  หรือเราดูแลให้บริการหลังการขาย การทำวิจัย และการสัมภาษณ์
                </p>
              </div>
            </li>
            <li>
              เมื่อท่านเข้าชม และ/หรือ ซื้อสินค้าออนไลน์
              หรือเข้าชมเว็บไซต์หรือแอปพลิเคชัน เราจะเก็บรวบรวมข้อมูลส่วนบุคคล
              ดังนี้
              <div>
                <p>
                  (1)&nbsp;&nbsp;ข้อมูลเกี่ยวกับการสมัครสมาชิก (Registration)
                  เช่น ชื่อ นามสกุล อีเมล เบอร์มือถือ รหัสผ่าน
                </p>
                <p>
                  (2)&nbsp;&nbsp;ข้อมูลเกี่ยวกับอุปกรณ์อิเล็กทรอนิกส์ที่ท่านใช้
                  เช่น IP Address ข้อมูลที่อยู่ (Location Data) Other device
                  identifier
                </p>
                <p>
                  (3)&nbsp;&nbsp;ชนิดและเวอร์ชันของบราวเซอร์ที่ท่านใช้
                  รวมถึงชนิดและเวอร์ชันของ plug-in ของบราวเซอร์
                </p>
                <p>(4)&nbsp;&nbsp;การตั้งค่าเขตเวลา (Time zone)</p>
              </div>
            </li>
            <li>
              เมื่อท่านติดต่อเรา หรือร่วมกิจกรรมใด ๆ กับเรา เช่น ติดต่อ Contact
              Center การทำ Customer Satisfaction กิจกรรมสิทธิประโยชน์ต่าง ๆ
              เราจะเก็บรวบรวมข้อมูลส่วนบุคคล เช่น
              <div>
                <p>
                  (1)&nbsp;&nbsp;ข้อมูลส่วนตัว เช่น ชื่อ นามสกุล
                  วันเดือนปีที่เกิด รูปถ่าย หมายเลขบัตรประชาชน หมายเลขใบขับขี่
                  หมายเลขหนังสือเดินทาง
                </p>
                <p>
                  (2)&nbsp;&nbsp;ข้อมูลการติดต่อ เช่น อีเมล เบอร์โทรศัพท์
                  ที่อยู่
                </p>
                <p>
                  (3)&nbsp;&nbsp;ข้อมูลเกี่ยวกับการร่วมกิจกรรม เช่น
                  ประวัติการร่วมกิจกรรมในครั้งก่อน ๆ ภาพถ่ายในแต่ละกิจกรรม
                </p>
              </div>
            </li>
            <li>
              เราอาจมีความจำเป็นต้องเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลชนิดพิเศษตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด
              เพื่อใช้งานตามวัตถุประสงค์ที่เราแจ้งไว้ในนโยบายความเป็นส่วนตัวนี้
              เช่น
              <div>
                <p>
                  (1)&nbsp;&nbsp;เมื่อเราจำเป็นต้องใช้ข้อมูลดังกล่าวเพื่อประโยชน์ในการรักษาความปลอดภัยของเรา
                  เช่น ข้อมูลชีวภาพ (facial recognition ลายนิ้วมือ)
                  เพื่อใช้ในการระบุตัวตน
                </p>
                <p>
                  (2)&nbsp;&nbsp;ในบางกรณี
                  เราอาจเก็บข้อมูลส่วนบุคคลชนิดพิเศษของท่าน
                  แม้ว่าสินค้าหรือบริการนั้นไม่ได้เกี่ยวข้องกับข้อมูลชนิดพิเศษโดยตรง
                  เช่น เราจำเป็นต้องใช้บัตรประชาชนของท่าน ซึ่งมีข้อมูลศาสนา
                  เพื่อใช้ในการยืนยันตัวตนของท่าน หรือดำเนินการทางภาษี
                </p>
                <p>
                  (3)&nbsp;&nbsp;ข้อมูลสุขภาพ เช่น ข้อมูลการแพ้อาหาร
                  เพื่อใช้ในการดำเนินกิจกรรมต่าง ๆ
                </p>
              </div>
            </li>
            <li>
              ในกรณีที่จำเป็น
              เราจะประมวลผลข้อมูลส่วนบุคคลชนิดพิเศษของท่านโดยได้รับความยินยอมโดยชัดแจ้งจากท่านหรือเพื่อวัตถุประสงค์อื่นตามที่กฎหมายกำหนดไว้เท่านั้น
              <p>
                ทั้งนี้
                เราจะใช้ความพยายามอย่างดีที่สุดในการจัดให้มีมาตรการรักษาความปลอดภัยที่เพียงพอเพื่อปกป้องคุ้มครองข้อมูลส่วนบุคคลชนิดพิเศษของท่าน
              </p>
            </li>
            <li>
              กรณีการอนุญาตให้ใช้สิทธิกับเรา
              เราจะเก็บรวบรวมข้อมูลส่วนบุคคลที่เกี่ยวข้อง (เช่น กรรมการ พนักงาน
              ผู้ปฏิบัติงาน และลูกค้า) เช่น
              <div>
                (1)&nbsp;&nbsp;ข้อมูลส่วนตัว เช่น ชื่อ นามสกุล ชื่อเล่น
                วันเดือนปีที่เกิด รูปถ่าย
                ข้อมูลตามที่ระบุในบัตรประจำตัวประชาชนและ/หรือ ใบขับขี่
                (2)&nbsp;&nbsp;ข้อมูลการติดต่อ เช่น เบอร์โทรศัพท์ อีเมล ที่อยู่
                ช่องทางติดต่อในโซเชียลมีเดีย ที่อยู่ เบอร์โทรศัพท์
                และเบอร์โทรสารทางธุรกิจ (3)&nbsp;&nbsp;ข้อมูลเกี่ยวกับงาน เช่น
                อาชีพ ตำแหน่ง วันที่เริ่มงาน ประเภทงาน สังกัดโรงงาน
                ประวัติการทำงานและฝึกอบรม (4)&nbsp;&nbsp;ข้อมูลเกี่ยวกับการศึกษา
                เช่น วุฒิการศึกษา
              </div>
            </li>
          </ol>
        </li>
        <li>
          คุกกี้
          <p>
            เรามีการใช้คุกกี้เพื่อเก็บรวบรวมข้อมูลส่วนบุคคล ตามที่กำหนดไว้ตาม
            นโยบายการใช้คุกกี้
          </p>
        </li>
        <li>
          การขอความยินยอมและผลกระทบที่เป็นไปได้จากการถอนความยินยอม
          <ol>
            <li>
              ในกรณีที่เราเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลโดยอาศัยความยินยอมของท่าน
              ท่านมีสิทธิที่จะถอนความยินยอมของท่านที่ให้ไว้กับเราได้ตลอดเวลา
              ซึ่งการถอนความยินยอมนี้จะไม่ส่งผลกระทบต่อการเก็บรวบรวม ใช้ เปิดเผย
              หรือประมวลผลข้อมูลส่วนบุคคลที่ท่านได้ให้ความยินยอมไปแล้ว
            </li>
            <li>
              หากท่านถอนความยินยอมที่ได้ให้ไว้กับเราหรือปฏิเสธไม่ให้ข้อมูลบางอย่าง
              อาจส่งผลให้เราไม่สามารถดำเนินการเพื่อบรรลุวัตถุประสงค์บางส่วนหรือทั้งหมดตามที่ระบุไว้ในนโยบายความเป็นส่วนตัวนี้ได้
            </li>
            <li>
              หากท่านมีอายุไม่ครบ 20 ปีบริบูรณ์
              ก่อนการให้ความยินยอมโปรดแจ้งรายละเอียดผู้ใช้อำนาจปกครองให้เราทราบเพื่อให้เราสามารถดำเนินการขอความยินยอมจากผู้ใช้อำนาจปกครองด้วย
            </li>
          </ol>
        </li>
        <li>
          ระยะเวลาในการเก็บรักษาข้อมูลส่วนบุคคล
          <ol>
            <li>
              เราจะเก็บข้อมูลส่วนบุคคลของท่านในระยะเวลาที่จำเป็นเพื่อให้บรรลุวัตถุประสงค์ตามประเภทข้อมูลส่วนบุคคลแต่ละประเภท
              เว้นแต่กฎหมายจะอนุญาตให้มีระยะเวลาการเก็บรักษาที่นานขึ้น
              ในกรณีที่ไม่สามารถระบุระยะเวลาการเก็บรักษาข้อมูลส่วนบุคคลได้ชัดเจน
              เราจะเก็บรักษาข้อมูลไว้ตามระยะเวลาที่อาจคาดหมายได้ตามมาตรฐานของการเก็บรวบรวม
              (เช่น อายุความตามกฎหมายทั่วไปสูงสุด 10 ปี)
            </li>
            <li>
              เราจัดให้มีระบบการตรวจสอบเพื่อดำเนินการลบหรือทำลายข้อมูลส่วนบุคคลเมื่อพ้นกำหนดระยะเวลาการเก็บรักษาหรือที่ไม่เกี่ยวข้องหรือเกินความจำเป็นตามวัตถุประสงค์ในการเก็บรวบรวมข้อมูลส่วนบุคคลนั้น
            </li>
            <li>
              กรณีที่เราใช้ข้อมูลส่วนบุคคลของท่านโดยขอความยินยอมจากท่าน
              เราจะประมวลผลข้อมูลส่วนบุคคลดังกล่าวจนกว่าท่านจะแจ้งขอยกเลิกความยินยอมและเราดำเนินการตามคำขอของท่านเสร็จสิ้นแล้ว
              อย่างไรก็ดี
              เราจะยังเก็บข้อมูลส่วนบุคคลของท่านเท่าที่จำเป็นสำหรับบันทึกเป็นประวัติว่าท่านเคยยกเลิกความยินยอม
              เพื่อให้ เราสามารถตอบสนองต่อคำขอของท่านในอนาคตได้
            </li>
          </ol>
        </li>
        <li>
          การเปิดเผยข้อมูลส่วนบุคคลให้บุคคลอื่น
          <ol>
            <li>
              เราเปิดเผยและแบ่งปันข้อมูลส่วนบุคคลของท่านกับ
              <div>
                <p>(1)&nbsp;&nbsp;บริษัทในกลุ่ม และ</p>
                <p>
                  (2)&nbsp;&nbsp;บุคคลและนิติบุคคลอื่นที่ไม่ได้เป็นบริษัทในกลุ่มของเรา
                  ("บุคคลอื่น")
                  เพื่อบรรลุวัตถุประสงค์การเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลตามที่ระบุไว้ในนโยบายความเป็นส่วนตัวนี้
                  เช่น ผู้แทนจำหน่ายของเรา ผู้ให้บริการด้านการขนส่ง (เช่น
                  ไปรษณีย์)
                  ผู้ให้บริการภายนอกที่ให้บริการและทำหน้าที่ภายใต้การควบคุมของเรา
                  เช่น ช่วยในการประมวลผลการทำรายการ
                  ส่งโฆษณาสำหรับผลิตภัณฑ์และบริการของเรา
                  หรือให้ความช่วยเหลือและบริการแก่ท่าน
                  ผู้ให้บริการเกี่ยวกับธุรกรรมและการเงิน (เช่น ธนาคาร
                  บริษัทรับชำระเงินแทน) ผู้ให้บริการทางด้านเทคโนโลยี (เช่น
                  ระบบคลาวด์ ระบบบล็อคเชน บริการส่ง SMS บริการ data analytics)
                  ผู้ให้บริการจัดทำโปรแกรมและระบบไอทีต่าง ๆ ผู้ตรวจสอบ
                  บริษัทประกัน ที่ปรึกษา หน่วยงานของรัฐ (เช่น กรมสรรพากร
                  สำนักงานคณะกรรมการป้องกันและปราบปรามการฟอกเงิน)
                  และบุคคลอื่นที่จำเป็นเพื่อให้เราสามารถดำเนินธุรกิจและให้บริการแก่ท่าน
                  รวมถึงดำเนินการใด ๆ
                  ตามวัตถุประสงค์การเก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลตามที่ระบุไว้ในนโยบายความเป็นส่วนตัวนี้
                </p>
              </div>
            </li>
            <li>
              เราจะกำหนดให้ผู้ที่ได้รับข้อมูลมีมาตรการปกป้องข้อมูลของท่านอย่างเหมาะสมและประมวลผลข้อมูลส่วนบุคคลดังกล่าวเท่าที่จำเป็นเท่านั้น
              และดำเนินการเพื่อป้องกันไม่ให้ใช้หรือเปิดเผยข้อมูลส่วนบุคคลโดยปราศจากอำนาจโดยมิชอบ
            </li>
          </ol>
        </li>
        <li>
          การส่งหรือโอนข้อมูลส่วนบุคคลไปต่างประเทศ
          <ol>
            <li>
              เราอาจส่งหรือโอนข้อมูลส่วนบุคคลของท่านไปยังบริษัทในเครือหรือบุคคลอื่นในต่างประเทศในกรณีที่จำเป็นเพื่อการปฏิบัติตามสัญญาซึ่งท่านเป็นคู่สัญญา
              หรือเป็นการกระทำตามสัญญาระหว่างเรากับบุคคลหรือนิติบุคคลอื่นเพื่อประโยชน์ของท่านหรือเพื่อใช้ในการดำเนินการตามคำขอของท่านก่อนเข้าทำสัญญา
              หรือเพื่อป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย
              หรือสุขภาพของท่านหรือบุคคลอื่น เพื่อปฏิบัติตามกฎหมาย
              หรือเป็นการจำเป็นเพื่อดำเนินภารกิจเพื่อประโยชน์สาธารณะที่สำคัญ
            </li>
            <li>
              เราอาจเก็บข้อมูลของท่านบนคอมพิวเตอร์เซิร์ฟเวอร์หรือคลาวด์ที่ให้บริการโดยบุคคลอื่น
              และอาจใช้โปรแกรมหรือแอปพลิเคชันของบุคคลอื่นในรูปแบบของการให้บริการซอฟท์แวร์สำเร็จรูปและรูปแบบของการให้บริการแพลตฟอร์มสำเร็จรูปในการประมวลผลข้อมูลส่วนบุคคลของท่าน
              แต่เราจะไม่อนุญาตให้บุคคลที่ไม่เกี่ยวข้องสามารถเข้าถึงข้อมูลส่วนบุคคลได้
              และจะกำหนดให้บุคคลอื่นเหล่านั้นต้องมีมาตรการคุ้มครองความมั่นคงปลอดภัยที่เหมาะสม
            </li>
            <li>
              ในกรณีที่มีการส่งข้อมูลส่วนบุคคลของท่านไปยังต่างประเทศ
              เราจะปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลและใช้มาตรการที่เหมาะสมเพื่อทำให้มั่นใจได้ว่าข้อมูลส่วนบุคคลของท่านจะได้รับการคุ้มครองและท่านสามารถใช้สิทธิที่เกี่ยวข้องกับข้อมูลส่วนบุคคลของท่านได้ตามกฎหมาย
              รวมถึงเราจะกำหนดให้ผู้ที่ได้รับข้อมูลมีมาตรการปกป้องข้อมูลของท่านอย่างเหมาะสมและประมวลผลข้อมูลส่วนบุคคลดังกล่าวเท่าที่จำเป็นเท่านั้น
              และดำเนินการเพื่อป้องกันไม่ให้บุคคลอื่นใช้หรือเปิดเผยข้อมูลส่วนบุคคลโดยปราศจากอำนาจโดยมิชอบ
            </li>
          </ol>
        </li>
        <li>
          มาตรการความปลอดภัยสำหรับข้อมูลส่วนบุคคล
          <ol>
            <li>
              ความปลอดภัยของข้อมูลส่วนบุคคลของท่านเป็นสิ่งสำคัญสำหรับเราและเราได้นำมาตรฐานความปลอดภัยทางเทคนิคและการบริหารที่เหมาะสมมาใช้เพื่อปกป้องข้อมูลส่วนบุคคลจากการสูญหาย
              การเข้าถึงการใช้หรือการเปิดเผยโดยไม่ได้รับอนุญาต
              การใช้งานในทางที่ผิด การดัดแปลงเปลี่ยนแปลง
              และการทำลายโดยใช้เทคโนโลยีและขั้นตอนการรักษาความปลอดภัย เช่น
              การเข้ารหัสและการจำกัดการเข้าถึง
              เพื่อให้มั่นใจว่าบุคคลที่ได้รับอนุญาตเท่านั้นที่เข้าถึงข้อมูลส่วนบุคคลของท่านและบุคคลเหล่านี้ได้รับการฝึกอบรมเกี่ยวกับความสำคัญของการปกป้องข้อมูลส่วนบุคคล
            </li>
            <li>
              เราจัดให้มีมาตรการรักษาความปลอดภัยที่เหมาะสม เพื่อป้องกันการสูญหาย
              เข้าถึง ใช้ เปลี่ยนแปลง แก้ไข
              เปิดเผยข้อมูลส่วนบุคคลจากผู้ที่ไม่มีสิทธิหรือหน้าที่ที่เกี่ยวข้องกับข้อมูลส่วนบุคคลนั้น
              และจะจัดให้มีการทบทวนมาตรการดังกล่าวเมื่อมีความจำเป็นหรือเมื่อเทคโนโลยีเปลี่ยนแปลงไปเพื่อให้มีประสิทธิภาพในการรักษาความปลอดภัยที่เหมาะสม
            </li>
          </ol>
        </li>
        <li>
          สิทธิเกี่ยวกับข้อมูลส่วนบุคคลของท่าน
          <ol>
            <li>
              ท่านมีสิทธิตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล สรุปดังนี้
              <div>
                <p>
                  (1)&nbsp;&nbsp;ถอนความยินยอมที่ท่านได้ให้ไว้กับเรา
                  เพื่อประมวลผลข้อมูลส่วนบุคคลของท่าน
                </p>
                <p>
                  (2)&nbsp;&nbsp;ขอดูและคัดลอกข้อมูลส่วนบุคคลของท่าน
                  หรือขอให้เปิดเผยที่มาของข้อมูลส่วนบุคคลของท่าน
                </p>
                <p>
                  (3)&nbsp;&nbsp;ส่งหรือโอนข้อมูลส่วนบุคคลที่อยู่ในรูปแบบอิเล็กทรอนิกส์ตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนดไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่น
                </p>
                <p>
                  (4)&nbsp;&nbsp;คัดค้านการเก็บรวบรวม ใช้
                  หรือเปิดเผยข้อมูลส่วนบุคคลที่เกี่ยวกับท่าน
                </p>
                <p>
                  (5)&nbsp;&nbsp;ลบหรือทำลาย
                  หรือทำให้ข้อมูลส่วนบุคคลของท่านเป็นข้อมูลที่ไม่สามารถระบุตัวตนของท่านได้
                  (anonymous)
                </p>
                <p>(6)&nbsp;&nbsp;ระงับการใช้ข้อมูลส่วนบุคคลของท่าน</p>
                <p>
                  (7)&nbsp;&nbsp;แก้ไขข้อมูลส่วนบุคคลของท่านให้ถูกต้อง
                  เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด
                </p>
                <p>
                  (8)&nbsp;&nbsp;ร้องเรียนต่อคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล
                  ในกรณีที่เราหรือผู้ประมวลผลข้อมูลส่วนบุคคล
                  รวมทั้งลูกจ้างหรือผู้รับจ้างของเราหรือผู้ประมวลผลข้อมูลส่วนบุคคลฝ่าฝืนหรือไม่ปฏิบัติตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล
                </p>
                <p>
                  ทั้งนี้
                  เราจะพิจารณาและแจ้งผลการพิจารณาตามคำร้องขอใช้สิทธิของท่านโดยเร็วภายใน
                  30 วันนับแต่วันที่เราได้รับคำร้องขอดังกล่าว
                  และสิทธิตามที่กล่าวมาข้างต้น
                  เป็นไปตามที่กฎหมายคุ้มครองข้อมูลส่วนบุคคลกำหนด
                </p>
              </div>
            </li>
          </ol>
        </li>
        <li>
          ข้อมูลเกี่ยวกับผู้ควบคุมข้อมูลส่วนบุคคลและเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล
          <ol>
            <li>
              ผู้ควบคุมข้อมูลส่วนบุคคล: บริษัท ฟู้ดกูรู จำกัด
              <p>
                สถานที่ติดต่อ: เลขที่ 58 ชั้นที่ 2 ซอยเพชรเกษม 41 ถนนเพชรเกษม
                แขวงบางแค เขตบางแค กรุงเทพฯ 10160
              </p>
            </li>
            <li>
              กรณีที่ท่านมีข้อสอบถามเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล
              <p>
                โปรดติดต่อเบอร์ 02-267-7888 (วันจันทร์ – วันศุกร์ เวลา 8.00 –
                17.00 น.) หรือ E-mail : aroi@foodguru.co.th
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p class="indent">
        กรณีที่มีการแก้ไขเปลี่ยนแปลงนโยบายความเป็นส่วนตัวนี้
        เราจะประกาศนโยบายความเป็นส่วนตัวฉบับใหม่ผ่านทางเว็บไซต์นี้
        ซึ่งท่านควรเข้ามาตรวจสอบความเปลี่ยนแปลงนโยบายความเป็นส่วนตัวเป็นครั้งคราว
        โดยนโยบายความเป็นส่วนตัวฉบับใหม่จะมีผลบังคับใช้ทันทีในวันที่ประกาศ
      </p>

      <div>
        <v-checkbox
          style="font-weight: 400"
          label="ยอมรับข้อตกลงและเงื่อนไข"
          v-model="cbagree"
          color="primary"
        ></v-checkbox>
      </div>
    </v-card>

    <div class="px-5 py-2">
      <v-btn
        @click="agree"
        :loading="saveloading"
        style="font-size: 16px; color: #fff; height: 48px; width: 150px"
        class="text-capitalize mx-auto"
        color="primary"
        :dark="cbagree"
        :disabled="!cbagree"
        block
        >ตกลง</v-btn
      >
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'

export default {
  data() {
    return {
      cbagree: false,
      saveloading: false,
      userid: null
    }
  },
  props: {
    pageid: { default: null }
  },
  methods: {
    async agree() {
      var data = {
        userid: this.$route.query.userid,
        pageid: this.pageid
      }

      let response = await axios.post(
        config.getConfig('serverUrl') + 'foodguru/confirmPdpa',
        data,
        {
          headers: {
            AUTHORIZATION: 'Bearer xxx xxx'
          }
        }
      )

      response = response.data
      if (response.responsecode == 200) {
        if (this.$liff.isInClient()) {
          // eslint-disable-next-line no-undef
          await this.$liff.sendMessages([
            {
              type: 'text',
              text: 'สั่งซื้อสินค้า'
            }
          ])

          // eslint-disable-next-line no-undef
          await this.$liff.closeWindow()
        }

        this.$emit('close')

        this.userid = this.$route.query.userid
        let url = '/ecommerce/' + this.pageid
        if (this.userid && this.userid != null && this.userid != '') {
          url += '?userid=' + this.userid
        }
        this.$router.push({ path: url })
      } else {
        await this.$swal.fire({
          text: response.data.reason
        })
      }
    }
    // pagename: function() {
    //   return this.$route.query.pageid
    //     ? this.$route.query.pageid
    //     : this.$route.params.id
    //     ? this.$route.params.id
    //     : undefined;
    // },
  }
}
</script>

<style lang="scss" scoped>
html {
  height: 100%;
}
ul {
  li {
    line-height: 24px;
  }
}
ol {
  counter-reset: item;
  li {
    display: block;
    margin-bottom: 8px;
    line-height: 24px;
    &:before {
      content: counters(item, '.') '. ';
      counter-increment: item;
    }
    div {
      padding-left: 16px;
    }
  }
}
.indent {
  text-indent: 24px;
}
p {
  margin-bottom: 8px !important;
  line-height: 24px;
}
</style>
